import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";

const IMG = "https://images.unsplash.com/photo-1693944844665-ce10f83a775b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState({ new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const requestLink = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const doReset = async (e) => {
    e.preventDefault();
    if (pwd.new_password.length < 8) { toast.error("A password deve ter pelo menos 8 caracteres."); return; }
    if (pwd.new_password !== pwd.confirm) { toast.error("As passwords não coincidem."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd.new_password });
      toast.success("Password redefinida! Já podes entrar.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="h-screen overflow-hidden grid lg:grid-cols-2 bg-[#FCFCFA]">
      <div className="relative hidden lg:block h-screen">
        <img src={IMG} alt="Porto" className="w-full h-full object-cover" style={{ objectPosition: "center 62%" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#26130E]/70 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12"><Logo variant="light" className="h-12" /><p className="sc-label text-[#F7EEC7] mt-4">Porto · Membros</p></div>
      </div>

      <div className="flex items-center justify-center px-6 sm:px-12 py-16 h-screen overflow-y-auto">
        <div className="w-full max-w-md sc-fade-up">
          <Link to="/login" className="sc-label text-[#6E5F58] hover:text-[#48020C]">← Entrar</Link>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#26130E] mt-6">Recuperar password</h1>

          {token ? (
            <>
              <p className="text-[#6E6359] mt-3">Define a tua nova password.</p>
              <form onSubmit={doReset} data-testid="reset-form" className="mt-10 space-y-6">
                <div className="space-y-2"><Label className="sc-label">Nova password</Label><Input data-testid="reset-new" type="password" required value={pwd.new_password} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} className="sc-input" placeholder="Pelo menos 8 caracteres" /></div>
                <div className="space-y-2"><Label className="sc-label">Confirmar password</Label><Input data-testid="reset-confirm" type="password" required value={pwd.confirm} onChange={(e) => setPwd({ ...pwd, confirm: e.target.value })} className="sc-input" placeholder="Repete a password" /></div>
                <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-[#48020C] hover:bg-[#26130E] disabled:opacity-60 text-[#FCFCFA] font-medium rounded-full py-4 transition-colors">{loading ? "A guardar…" : "Guardar nova password"}</button>
              </form>
            </>
          ) : sent ? (
            <div data-testid="forgot-sent" className="mt-8 bg-[#F4F1EA] border border-[#E3DED2] rounded-2xl p-6">
              <p className="text-[#26130E]">Se existir uma conta com esse email, enviámos um link para repor a password. Verifica a tua caixa de entrada (e o spam). O link é válido durante 1 hora.</p>
            </div>
          ) : (
            <>
              <p className="text-[#6E6359] mt-3">Indica o teu email e enviamos-te um link para definir uma nova password.</p>
              <form onSubmit={requestLink} data-testid="forgot-form" className="mt-10 space-y-6">
                <div className="space-y-2"><Label className="sc-label">Email</Label><Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="sc-input" placeholder="email@exemplo.com" /></div>
                <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-[#48020C] hover:bg-[#26130E] disabled:opacity-60 text-[#FCFCFA] font-medium rounded-full py-4 transition-colors">{loading ? "A enviar…" : "Enviar link de recuperação"}</button>
              </form>
            </>
          )}
          <style>{`.sc-input{background:#F4F1EA;border-color:#E3DED2;border-radius:0.75rem;padding:0.75rem 1rem;height:auto;}`}</style>
        </div>
      </div>
    </div>
  );
}
